export default {"src":"/_next/static/media/UPS.d12e8e66.svg","height":18,"width":18};